import React, { useCallback, useEffect, useState } from 'react'
import {
  _captchaToken,
  _isChallengeRequired,
  _startSellingOnFlip,
} from 'constants/recaptcha'
import { useFormikContext } from 'formik'

const recaptchaId = 'recaptchaId'
const recaptchaChallengeKey = process.env.RECAPTCHA_CHALLENGE_KEY

const Recaptcha = () => {
  const { values, setFieldValue } = useFormikContext()
  const [rendered, setRendered] = useState(false)
  const isCaptchaRequired = values && values[_isChallengeRequired]
  const isSSR = typeof window === 'undefined'

  const onCaptchaChange = useCallback(key => {
    if (key) {
      setFieldValue(_captchaToken, key)
    } else {
      setFieldValue(_captchaToken, '')
    }
  }, [])

  useEffect(() => {
    if (isCaptchaRequired && !rendered && !isSSR) {
      setTimeout(() => {
        const recaptcha = window?.grecaptcha?.enterprise

        if (recaptcha && recaptcha.render) {
          recaptcha.render(recaptchaId, {
            sitekey: recaptchaChallengeKey,
            action: _startSellingOnFlip,
            callback: onCaptchaChange,
            'expired-callback': onCaptchaChange,
          })

          setRendered(true)
        }
      }, 1000)
    }
  }, [isCaptchaRequired, rendered, isSSR])

  return <div id={recaptchaId} />
}

export default Recaptcha
